// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeMemberApproveBody = {
  poolId: string;
  targetUserId: string;
};

export type typeMemberApproveOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { targetUserId: string; status: "active" };
};

export type typeMemberApproveOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMemberApproveOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMemberApproveOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaMemberApproveBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    targetUserId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "targetUserId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createMemberApprove(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaMemberApproveBody);
  }

  return async function postMemberApprove(
    payload: typeMemberApproveBody,
  ): Promise<typeMemberApproveOutput200 | typeMemberApproveOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postMemberApprove" failed before calling the network. #1b033ee4df4b`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#1b033ee4df4b" },
        },
        data: null,
      } as typeMemberApproveOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/member/approve`,
      httpMethod: "POST",
      options,
    })) as typeMemberApproveOutput200 | typeMemberApproveOutput400;
  };
}
